import type { Request } from '@adornis/abac/core/Request.js';
import type { IPolicy } from '@adornis/abac/core/types.js';
import { isLMSPayload, LMSAction } from '@nsc/simple-lms/init.js';

const ENROLLMENT_OWNER_ACTIONS = new Set<LMSAction>([LMSAction.SubmitAnswer, LMSAction.CompleteAttempt]);

const AUTH_ONLY_ACTIONS = new Set<LMSAction>([LMSAction.ViewCourse, LMSAction.ViewCoursePages]);

export const SmartTeamsLMSPolicy: IPolicy = {
  name: 'SmartTeamsLMSPolicy',

  async evaluate(request: Request) {
    const payload = request.payload;
    if (!isLMSPayload(payload)) return false;

    const { action, userId: currentUserId, enrollmentUserId } = payload;

    if (AUTH_ONLY_ACTIONS.has(action)) {
      return currentUserId
        ? { allowed: true, reason: 'authenticated user' }
        : { allowed: false, reason: 'not authenticated' };
    }

    if (ENROLLMENT_OWNER_ACTIONS.has(action)) {
      if (!currentUserId) return { allowed: false, reason: 'not authenticated' };
      if (!enrollmentUserId) return { allowed: false, reason: 'enrollment context missing' };
      return currentUserId === enrollmentUserId
        ? { allowed: true, reason: 'enrollment owner' }
        : { allowed: false, reason: 'user does not own this enrollment' };
    }

    return false;
  },
};
